import React from "react";
import { I18n } from "../../../../i18n/i18n";
import { FacebookIcon, TwitterIcon } from "../../../icons";

import "@styles/c-socialShare.scss";

interface Props {
  i18n: I18n;
  facebookShareUrl: string;
  twitterShareUrl: string;
  onShared?: () => void;
}

export const SocialShareComponent: React.FC<Props> = ({ i18n, facebookShareUrl, twitterShareUrl, onShared }) => {
  return (
    <div className="c-socialShare">
      <ul className="c-socialShare__list">
        <li className="c-socialShare__item">
          <a className="c-socialShare__button" href={facebookShareUrl} target="__blank" onClick={() => onShared && onShared()}>
            <FacebookIcon />
            <span className="c-socialShare__buttonLabel">{i18n.facebook}</span>
          </a>
        </li>
        <li className="c-socialShare__item">
          <a className="c-socialShare__button" href={twitterShareUrl} target="__blank" onClick={() => onShared && onShared()}>
            <TwitterIcon />
            <span className="c-socialShare__buttonLabel">{i18n.twitter}</span>
          </a>
        </li>
      </ul>
    </div>
  );
};
